type DeliveryOption = 'HOJE' | 'AMANHÃ' | 'NOTURNA' | 'URGENTE';

const SAO_PAULO_TZ = 'America/Sao_Paulo';

// Mapeamento dos nomes de categoria para horários de corte
const CUTOFF_BY_SERVICE: Record<string, string> = {
  'IMPRESSÃO DTF TÊXTIL': '16:00',
  'DTF TÊXTIL': '16:00',
  'IMPRESSÃO SUBLIMÁTICA': '16:00',
  'SUBLIMAÇÃO': '16:00',
  'IMPRESSÃO DTF UV': '17:00',
  'DTF UV': '17:00',
  'ADESIVO UV': '16:00',
  'CAMISETA': '16:00'
};

function parseTimeToToday(timeHHmm: string, now: Date): Date {
  const [hh, mm] = timeHHmm.split(':').map((x) => Number(x));
  const d = new Date(now);
  d.setHours(hh, mm, 0, 0);
  return d;
}

function isWeekend(date: Date): boolean {
  const day = date.getDay();
  return day === 0 || day === 6; // dom(0) ou sáb(6)
}

export function getDefaultDelivery(serviceType: string, now = new Date()): DeliveryOption {
  const cutoff = CUTOFF_BY_SERVICE[serviceType] || '16:00';
  const cutoffToday = parseTimeToToday(cutoff, now);
  // Usamos hora local da máquina; assumimos TZ configurado para America/Sao_Paulo no ambiente
  return now.getTime() < cutoffToday.getTime() ? 'HOJE' : 'AMANHÃ';
}

export function normalizeDelivery(option: DeliveryOption, serviceType: string, now = new Date()): DeliveryOption {
  if (option === 'NOTURNA' || option === 'URGENTE') return 'HOJE';
  if (option === 'AMANHÃ') return 'AMANHÃ';
  return getDefaultDelivery(serviceType, now);
}

export function shiftToNextBusinessDay(date: Date): Date {
  // Considera somente segunda a sexta. Lista de feriados nacionais pode ser adicionada futuramente.
  const d = new Date(date);
  while (isWeekend(d)) {
    d.setDate(d.getDate() + 1);
  }
  return d;
}

export type { DeliveryOption };


function formatYYYYMMDD(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function getDeliveryDate(option: DeliveryOption, serviceType: string, now = new Date()): string {
  const normalized = normalizeDelivery(option, serviceType, now);
  if (normalized === 'AMANHÃ') {
    const t = new Date(now);
    t.setDate(t.getDate() + 1);
    const next = shiftToNextBusinessDay(t);
    return formatYYYYMMDD(next);
  }
  // HOJE (inclui NOTURNA/URGENTE normalizados)
  const today = isWeekend(now) ? shiftToNextBusinessDay(now) : now;
  return formatYYYYMMDD(today);
}

